import { useState } from 'react';
import { faqs } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <SectionHeading eyebrow="常见问题" title="关于数字红包，你可能想了解" />

        <div className="mt-10 space-y-3">
          {faqs.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer transition-colors hover:bg-background-100"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full border border-background-200 text-foreground-500 transition-transform duration-300 ${
                      isOpen ? 'rotate-180 bg-secondary-100 text-secondary-700 border-secondary-200' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}